import { render, staticRenderFns } from "./PageHeight.vue?vue&type=template&id=54855db6"
import script from "./PageHeight.vue?vue&type=script&lang=js"
export * from "./PageHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports